import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/admin/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';
import { ADMIN_LOGIN_PATH } from './config';

import News from './components/News/News';
import Separate from './components/Separate/Separate';
import EventsPage from './pages/public/EventsPage';
import EventDetail from './pages/public/EventDetail';
import NotFound from './pages/NotFound';

import AdminLogin from './pages/admin/AdminLogin';
import Dashboard from './pages/admin/Dashboard';
import BackgroundsManager from './pages/admin/BackgroundsManager';
import EventsList from './pages/admin/EventsList';
import EventForm from './pages/admin/EventForm';
import NewsList from './pages/admin/NewsList';
import NewsPostForm from './pages/admin/NewsPostForm';
import MembersList from './pages/admin/MembersList';
import MemberForm from './pages/admin/MemberForm';

const adminProtectedRoutes = {
  path: '',
  element: (
    <ProtectedRoute>
      <AdminLayout />
    </ProtectedRoute>
  ),
  children: [
    { index: true, element: <Navigate to="dashboard" replace /> },
    { path: 'dashboard', element: <Dashboard /> },
    { path: 'backgrounds', element: <BackgroundsManager /> },
    { path: 'events', element: <EventsList /> },
    { path: 'events/new', element: <EventForm /> },
    { path: 'events/:id', element: <EventForm /> },
    { path: 'news', element: <NewsList /> },
    { path: 'news/new', element: <NewsPostForm /> },
    { path: 'news/:id', element: <NewsPostForm /> },
    { path: 'members', element: <MembersList /> },
    { path: 'members/new', element: <MemberForm /> },
    { path: 'members/:id', element: <MemberForm /> },
  ],
};

const adminRoutes = {
  path: '/admin',
  errorElement: <NotFound />,
  children: [
    { path: 'login', element: <AdminLogin /> },
    adminProtectedRoutes,
  ],
};

// Optional secret alias from .env (e.g. /ici-manage-7f3a9c)
const secretLoginRoute =
  ADMIN_LOGIN_PATH !== '/admin/login'
    ? [{ path: ADMIN_LOGIN_PATH, element: <AdminLogin /> }]
    : [];

const router = createBrowserRouter([
  { path: '/', element: <App />, errorElement: <NotFound /> },
  { path: '/events', element: <EventsPage />, errorElement: <NotFound /> },
  { path: '/events/:id', element: <EventDetail />, errorElement: <NotFound /> },
  { path: '/news', element: <News />, errorElement: <NotFound /> },
  { path: '/news/:id', element: <Separate />, errorElement: <NotFound /> },
  adminRoutes,
  ...secretLoginRoute,
  { path: '*', element: <NotFound /> },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
